<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-form ref="CoreTimeFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span
              >{{ data && data.name }}'s MPOR for the Month of
              {{
                data
                  ? monthSelection3[data.mnth - 1].name + " " + data.year
                  : null
              }}
            </span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-card>
              <v-row>
                <v-col cols="8" class="flex-items mt-2">
                  <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                    <v-tab
                      v-for="tab in tabList"
                      :key="tab.id"
                      @click="changeTab(tab)"
                      >{{ tab.name }}</v-tab
                    >
                  </v-tabs>
                </v-col>
                <v-spacer></v-spacer>
                <!-- <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
                  <v-autocomplete
                    @change="changeMPOR()"
                    v-model="selectedMonth"
                    dense
                    outlined
                    class="rounded-lg"
                    item-text="name"
                    item-value="id"
                    label="Month"
                    color="#93CB5B"
                    :items="monthsList"
                  ></v-autocomplete>
                </v-col> -->
                <v-col cols="12" class="pt-2 px-4" v-if="tab != 3">
                  <v-data-table
                    :expanded.sync="expanded"
                    :headers="headers"
                    :items="dataItem"
                    :items-per-page="-1"
                    show-expand
                  >
                    <template v-slot:[`item.suc_ind`]="{ item }">
                      <div class="text-justify">
                        {{ getItemSuccessIndicator(item) }}
                      </div>
                    </template>
                    <template v-slot:[`item.efficiency`]="{ item }">
                      {{ item.mpor ? getTotal("E", item) : "" }}
                    </template>
                    <template v-slot:[`item.quality`]="{ item }">
                      {{ item.mpor ? getTotal("Q", item) : "" }}
                    </template>
                    <template v-slot:[`item.timeliness`]="{ item }">
                      {{ item.mpor ? getTotal("T", item) : "" }}
                    </template>
                    <template v-slot:[`item.remarks`]="{ item }">
                      {{ item.mpor ? item.mpor.remarks : "" }}
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <table id="tbl_expanded">
                          <tr>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width: 33%"
                            >
                              Efficiency
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width: 33%"
                            >
                              Quality
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width: 33%"
                            >
                              Timeliness
                            </th>
                          </tr>
                          <tr>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                          </tr>

                          <tbody>
                            <tr>
                              <td
                                :colspan="!item.eff_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.eff_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.e_w1
                                }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w2 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w3 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w4 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("E", item) }}
                              </td>
                              <td
                                :colspan="!item.qly_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.qly_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.q_w1
                                }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w2 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w3 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w4 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("Q", item) }}
                              </td>
                              <td
                                :colspan="!item.timeliness_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.timeliness_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.t_w1
                                }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w2 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w3 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w4 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("T", item) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </template>
                    <template
                      v-slot:[`item.actions`]="{ item }"
                      v-if="toPending"
                    >
                      <v-btn
                        v-if="item.mpor.pendingRemarks.length > 0"
                        x-small
                        block
                        class="my-1"
                        color="primary"
                        outlined
                        @click="viewItem(item)"
                      >
                        view remarks
                      </v-btn>
                      <v-btn
                        block
                        x-small
                        class="my-1"
                        color="red"
                        outlined
                        @click="pendingItem(item)"
                      >
                        add pending remarks
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" class="pt-2 px-4" v-if="tab == 3">
                  <v-form ref="GDriveLinkRef">
                    <div class="pa-4 rounded-lg" style="border: 1px solid grey">
                      <div class="px-2">
                        <v-btn
                          class="btn-print"
                          style="width: 220px"
                          @click="showGDrive()"
                        >
                          View Google Drives
                        </v-btn>
                      </div>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
              <!-- <v-row class="pt-1" v-if="tab == 3">
                <v-col cols="12" class="py-2 px-4">
                  <div class="pa-2 rounded-md" style="border: 1px solid grey">
                    <div class="px-4 text-h5 py-2">Attachment</div>

                    <v-btn
                      color="#519043"
                      class="mx-1 white--text"
                      @click="viewAttachment()"
                      >View Attachment</v-btn
                    >
                  </div>
                </v-col>
              </v-row> -->
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-5" v-if="tabType == 1">
            <v-spacer></v-spacer>
            <!-- <v-btn
              v-if="action == 'approval'"
              color="red"
              class="white--text"
              @click="pending()"
              :disabled="isloading"
              :loading="isloading"
            >
              Pending
            </v-btn> -->

            <v-btn
              class="btn-pending"
              v-if="!toPending"
              outlined
              @click="setToPending()"
            >
              Pending
            </v-btn>

            <v-btn
              v-if="action == 'approval' && !toPending"
              class="btn-save"
              @click="approve()"
              :disabled="isloading"
              :loading="isloading"
            >
              Approve
            </v-btn>

            <v-btn
              class="btn-pending"
              style="min-width: 140px"
              :disabled="confirmLoading"
              v-if="toPending"
              outlined
              @click="cancelPending()"
            >
              Cancel Pending
            </v-btn>
            <v-btn
              v-if="toPending"
              class="btn-save"
              style="min-width: 140px"
              :disabled="confirmLoading"
              :loading="confirmLoading"
              @click="confirmPending()"
            >
              Confirm Pending
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="confirmDialog" persistent max-width="420">
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div
            class="submit-icon"
            :class="{
              approve: approvalAction === 'APPROVE',
              pending: approvalAction === 'PENDING',
            }"
          >
            <v-icon size="42" color="white">
              {{
                approvalAction === "APPROVE"
                  ? "mdi-check-circle"
                  : "mdi-clock-outline"
              }}
            </v-icon>
          </div>

          <div class="delete-title">
            {{
              approvalAction === "APPROVE"
                ? "Confirm Approval"
                : "Mark as Pending"
            }}
          </div>

          <div class="delete-description" v-html="confirmMsg"></div>
        </div>

        <v-divider></v-divider>

        <v-card-actions class="px-6 py-4">
          <v-spacer />

          <v-btn
            outlined
            color="grey darken-1"
            :disabled="confirmBtnLoading"
            @click="cancelConfirm()"
          >
            Cancel
          </v-btn>

          <v-btn
            color="success"
            class="white--text"
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            @click="openRemarksDialog()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- remarks dialog -->
    <v-dialog
      v-model="addRemarksDialog"
      persistent
      max-width="600"
      content-class="rounded-dialog"
    >
      <v-card color="white">
        <v-form ref="RemarksFormref" @submit.prevent>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="circle-add" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    {{
                      approvalAction == "APPROVE"
                        ? "Add Observation and Remarks"
                        : "Add Remarks"
                    }}
                  </div>

                  <div class="dialog-subtitle">
                    Fill in the required information below
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="addRemarksDialog = false">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 150px" class="my-4">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Type your remarks here ..."
                  v-model="remarksMsg"
                  outlined
                  dense
                  :rules="[formRules.required]"
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-cancel"
              outlined
              @click="addRemarksDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              v-if="approvalAction == 'APPROVE'"
              class="btn-save"
              @click="confirmSubmit()"
            >
              Approve
            </v-btn>
            <v-btn
              v-if="approvalAction == 'PENDING'"
              class="btn-pending"
              @click="savePendingRemarks()"
            >
              Pending
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <MPOROutputDialog :data="mporData" />
    <RemarksDialog
      :data="itemToPending"
      v-on:saveRemarks="saveRemarks"
      v-on:closeRemarks="closeRemarks"
      :type="type"
      :moduleFrom="'IPCR MPOR APPROVAL'"
    />

    <ViewRemarksTimelineDialog
      :data="list"
      v-on:closeRemarksTimeline="closeRemarksTimeline"
    />
    <WarningDialog :msg="cancelMsg" v-on:yes="yes" v-on:no="no" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="fadeAwayMessage.timeout"
    ></fade-away-message-component>
  </div>
</template>

<script>
import RemarksDialog from "./RemarksDialog.vue";
import ViewRemarksTimelineDialog from "./ViewRemarksTimelineDialog.vue";
import WarningDialog from "./WarningDialog.vue";

export default {
  components: {
    MPOROutputDialog: () => import("../Forms/MPOROutputDialog.vue"),
    RemarksDialog,
    ViewRemarksTimelineDialog,
    WarningDialog,
  },
  props: {
    data: null,
    action: null,
    tabType: null,
  },
  data() {
    return {
      isloading: null,
      confirmDialog: false,
      confirmMsg: null,
      confirmBtnLoading: false,
      approvalAction: null,
      addRemarksDialog: false,
      attachment: null,
      remarksMsg: null,
      loading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
        timeout: 1500,
      },
      options: {},

      expanded: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Attachment" },
      ],
      mporData: null,
      ipcrID: null,
      mnth: null,
      year: null,
      dataItem: [],
      monthsList: [],
      monthSelection1: [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
      ],
      monthSelection2: [
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ],
      monthSelection3: [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ],
      selectedMonth: null,
      headers: [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        // {
        //   text: "Attachment",
        //   value: "action",
        //   align: "end",
        //   width: 100,
        //   valign: "center",
        //   sortable: false,
        // },
      ],
      toPending: false,
      pendingList: [],
      type: null,
      list: [],
      confirmLoading: false,
      itemToPending: null,
      cancelMsg: null,
      submitAction: null,
    };
  },
  computed: {
    getIsSubmitted() {
      let toReturn = false;
      let submit = [];
      let approval = [];
      if (this.dataItem && this.dataItem.length > 0) {
        for (let i = 0; i < this.dataItem.length; i++) {
          submit.push(this.dataItem[i].mpor.isSubmitted);
          approval.push(this.dataItem[i].mpor.head_approval_status);
        }

        if (
          submit.includes(0) &&
          (approval.includes(1) || approval.includes(3))
        ) {
          toReturn = false;
        }

        if (
          !submit.includes(0) &&
          !(approval.includes(1) || approval.includes(3))
        ) {
          toReturn = true;
        }
      } else {
        toReturn = false;
      }
      return toReturn;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.pendingList = [];
        this.toPending = false;
        this.setHeaders();
        this.approvalAction = null;
        this.remarksMsg = null;
        this.tab = 1;
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.selectedMonth = data.mnth;
        this.ipcrID = data.ipcr_ID;
        this.mnth = data.mnth;
        this.year = data.year;

        this.initialize();
      },
      deep: true,
    },

    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeViewMPORApprovalDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeMPOROutputDialog");
  },
  methods: {
    initialize() {
      this.loading = true;
      this.axiosCall(
        "/ipcr-mpor/getMPORtoApprove/" +
          this.ipcrID +
          "/" +
          this.tab +
          "/" +
          this.mnth,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("MPOR", res.data);
          this.dataItem = res.data;
          this.loading = false;
        }
      });
    },
    setHeaders() {
      let headers = [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
      ];
      let headersWAction = [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Action",
          value: "actions",
          width: 200,
          align: "center",
          sortable: false,
        },
      ];

      this.headers = this.toPending ? headersWAction : headers;
    },
    setToPending() {
      this.toPending = true;
      this.setHeaders();
    },
    saveRemarks(data) {
      this.pendingList.push(data);
      console.log("calleded", this.pendingList);

      this.initialize();
    },
    closeRemarks(data) {
      this.itemToDelete = data;
    },
    closeRemarksTimeline() {
      this.list = [];
    },
    pendingItem(item) {
      this.type =
        this.tab == 1
          ? "Core Function"
          : this.tab == 2
          ? "Strategic Priority"
          : "";
      this.itemToPending = null;
      setTimeout(() => {
        this.itemToPending = item.mpor;
      }, 100);
      console.log("PENDING", item);
    },

    viewItem(item) {
      console.log(item.mpor.pendingRemarks);

      this.list = [];
      setTimeout(() => {
        this.list = item.mpor.pendingRemarks;
      }, 100);
    },

    confirmPending() {
      this.submitAction = "confirm pending";
      this.cancelMsg =
        "Are you sure you want to PENDING this? Please note that this action is irreversible.";
    },

    cancelPending() {
      this.submitAction = "cancel pending";
      if (this.pendingList.length > 0) {
        this.cancelMsg =
          "You have added pending remarks! Are you sure you want to CANCEL the Pending? Added remarks will not be saved.";
      } else {
        this.removePendingRemarks();
      }
    },

    submitForPending() {
      this.confirmLoading = true;
      let data = {
        ipcrID: this.ipcrID,
        mnth: this.mnth,
        year: this.year,
        remarks: null,
      };
      this.axiosCall("/ipcr-mpor/pending", "POST", data).then((res) => {
        if (res) {
          if (res.data.status == 200) {
            this.dialog = false;
            this.cancelMsg = null;
            this.confirmLoading = false;
            this.toPending = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.cancelMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      });
    },

    removePendingRemarks() {
      let data = {
        list: JSON.stringify(this.pendingList),
      };
      this.axiosCall("/remarks/remove-pending-remarks", "POST", data).then(
        (res) => {
          if (res.data.status == 200) {
            this.cancelMsg = null;
            this.toPending = false;
            this.pendingList = [];
            this.setHeaders();
            this.initialize();
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = "Pending Cancelled!";
            // this.closeD();
          } else if (res.data.status == 400) {
            this.cancelMsg = null;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    yes() {
      if (this.submitAction == "cancel pending") {
        this.removePendingRemarks();
        this.cancelMsg = null;
      }
      if (this.submitAction == "confirm pending") {
        this.submitForPending();
        this.cancelMsg = null;
      }
      if (this.submitAction == "approve") {
        this.showApprovalRemarks();
        this.cancelMsg = null;
      }
    },
    no() {
      this.submitAction = null;
      this.cancelMsg = null;
    },

    changeMPOR() {
      this.initialize();
    },

    getItemSuccessIndicator(item) {
      return item.efficiency_type == "percentage"
        ? item.efficiency +
            "%" +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness
        : item.efficiency +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness;
    },
    getTotal(field, item) {
      if (item) {
        let i = item.mpor;

        if (field == "E") {
          let total = 0;
          if (item.eff_is_rated) {
            total += i ? (i.e_w1 ? i.e_w1 : 0) : 0;
            total += i ? (i.e_w2 ? i.e_w2 : 0) : 0;
            total += i ? (i.e_w3 ? i.e_w3 : 0) : 0;
            total += i ? (i.e_w4 ? i.e_w4 : 0) : 0;
            return total;
          } else {
            return "Not to be Rated";
          }
        } else if (field == "Q") {
          let total = 0;
          if (item.qly_is_rated) {
            total += i ? (i.q_w1 ? i.q_w1 : 0) : 0;
            total += i ? (i.q_w2 ? i.q_w2 : 0) : 0;
            total += i ? (i.q_w3 ? i.q_w3 : 0) : 0;
            total += i ? (i.q_w4 ? i.q_w4 : 0) : 0;
            return total;
          } else {
            return "Not to be Rated";
          }
        } else if (field == "T") {
          let total = 0;
          if (item.timeliness_is_rated) {
            total += i ? (i.t_w1 ? i.t_w1 : 0) : 0;
            total += i ? (i.t_w2 ? i.t_w2 : 0) : 0;
            total += i ? (i.t_w3 ? i.t_w3 : 0) : 0;
            total += i ? (i.t_w4 ? i.t_w4 : 0) : 0;
            return total;
          } else {
            return "Not to be Rated";
          }
        }
      }
    },
    closeD() {
      if (this.pendingList.length > 0) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "warning";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.timeout = 5000;
        this.fadeAwayMessage.message =
          "You have added pending remarks! Please click the CANCEL PENDING button to cancel the pending process.";
      } else {
        this.addRemarksDialog = false;
        this.confirmDialog = false;
        this.dialog = false;
        this.eventHub.$emit("closeViewMPORApprovalDialog", false);
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },

    approve() {
      this.approvalAction = "APPROVE";
      this.cancelMsg =
        "Are you sure you want to APPROVE this? Please note that this action is irreversible.";
      this.submitAction = "approve";
    },

    showApprovalRemarks() {
      this.addRemarksDialog = true;
    },

    // approve() {
    //   this.approvalAction = "APPROVE";
    //   this.confirmMsg =
    //     "<p>Are you sure you want to <b>APPROVE</b> this MPOR</p>";
    //   this.confirmDialog = true;
    // },
    pending() {
      this.approvalAction = "PENDING";
      this.confirmMsg =
        "<p>Are you sure you want to <b>PENDING</b> this MPOR</p>";
      this.confirmDialog = true;
    },
    cancelConfirm() {
      this.confirmDialog = false;
    },
    openRemarksDialog() {
      this.remarksMsg = null;
      this.confirmDialog = false;
      this.addRemarksDialog = true;
    },
    confirmSubmit() {
      this.confirmDialog = false;
      if (this.$refs.RemarksFormref.validate()) {
        let data = {
          ipcrID: this.ipcrID,
          mnth: this.mnth,
          year: this.year,
          remarks: this.remarksMsg,
        };
        this.axiosCall("/ipcr-mpor/approve", "POST", data).then((res) => {
          if (res) {
            if (res.data.status == 200) {
              this.confirmDialog = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        });
      }
    },
    savePendingRemarks() {
      if (this.$refs.RemarksFormref.validate()) {
        let data = {
          ipcrID: this.ipcrID,
          mnth: this.mnth,
          year: this.year,
          remarks: this.remarksMsg,
        };
        this.axiosCall("/ipcr-mpor/pending", "POST", data).then((res) => {
          if (res) {
            if (res.data.status == 200) {
              this.confirmDialog = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        });
      }
    },
    viewAttachment() {
      this.getAttachment(this.data.mnth, this.data.ipcr_ID);
    },
    getAttachment(month, ipcrID) {
      this.axiosCall(
        "/ipcr-mpor/getMPORAttachment/" + ipcrID + "/" + month,
        "GET",
      ).then((res) => {
        // console.log(res);
        if (res) {
          let url =
            process.env.VUE_APP_SERVER +
            "/ipcr-target/previewFile/" +
            res.data.filename;

          let token = localStorage.getItem("token");
          const tab = window.open("about:blank");
          // this.isLoading = true;
          fetch(url, { headers: { Authorization: `Bearer ${token}` } })
            .then((response) => response.blob())
            .then((blob) => {
              var _url = window.URL.createObjectURL(blob);

              tab.location = _url;
              tab.focus();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    showGDrive() {
      console.log(this.data);
      this.axiosCall(
        "/ipcr/getMPORGDriveLink/" +
          this.data.ipcr_ID +
          "/" +
          this.selectedMonth,
        "GET",
      ).then((res) => {
        if (res.data !== null) {
          let url = res.data.link;
          window.open(url, "_blank");
        }
      });
    },
  },
};
</script>
<style scoped>
#tbl_expanded {
  border-collapse: collapse;
  width: 100%;
  padding: 5px;
}
#tbl_expanded table,
#tbl_expanded th,
#tbl_expanded td {
  border: 2px solid grey;
}
</style>
